import { AccessibilityParamsStore } from 'stores/global/AccessibilityParamsStore';
import { AnalyticsStore } from 'stores/global/AnalyticsStore';
import { SnackBarStore } from 'stores/global/SnackBarStore';
import { QpParamsStore } from 'stores/global/qpStore';
import { UserStore } from 'stores/global/user';

export class RootStore {
  readonly user = new UserStore();
  readonly qpStore = new QpParamsStore();
  readonly snackBar = new SnackBarStore();
  readonly accessibilityParams = new AccessibilityParamsStore();
  readonly analytics = new AnalyticsStore();
}
